import { render, staticRenderFns } from "./DetailSalePayment.vue?vue&type=template&id=5c3a8cba"
import script from "./DetailSalePayment.vue?vue&type=script&lang=js"
export * from "./DetailSalePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports